import { Component } from '@theme/component';
class OskerinComponent extends Component {
  connectedCallback() {super.connectedCallback();this.rebind();}
  updatedCallback() {super.updatedCallback();this.rebind();}
  disconnectedCallback() {this.controller?.abort();super.disconnectedCallback();}
  rebind() {this.controller?.abort();this.controller=new AbortController();this.setup(this.controller.signal);}
  setup(_signal) {}
}
class OskerinHeader extends OskerinComponent {
  setup(signal) {
    const header=this.querySelector('[data-osk-header]');if(!header)return;
    const update=()=>{header.classList.toggle('is-scrolled',window.scrollY>50);document.documentElement.style.setProperty('--osk-header-height',header.offsetHeight+'px');};
    update();window.addEventListener('scroll',update,{passive:true,signal});window.addEventListener('resize',update,{signal});
    const trigger=header.querySelector('.osk-menu-trigger'),mobile=header.querySelector('.osk-mobile-nav');
    if(!(trigger instanceof HTMLButtonElement)||!(mobile instanceof HTMLElement))return;
    const close=()=>{mobile.hidden=true;trigger.setAttribute('aria-expanded','false');for(const detail of header.querySelectorAll('details[open]'))detail.open=false;};
    trigger.addEventListener('click',()=>{const open=mobile.hidden;mobile.hidden=!open;trigger.setAttribute('aria-expanded',String(open));},{signal});
    document.addEventListener('keydown',event=>{if(event.key==='Escape')close();},{signal});
    document.addEventListener('click',event=>{if(event.target instanceof Node&&!header.contains(event.target))close();},{signal});
    for(const anchor of mobile.querySelectorAll('a'))anchor.addEventListener('click',close,{signal});
    window.addEventListener('pageshow',close,{signal});
  }
}
class OskerinCarousel extends OskerinComponent {
  setup(signal) {
    const slides=[...this.querySelectorAll('.osk-slide')],dots=[...this.querySelectorAll('[data-osk-dot]')],count=this.querySelector('[data-osk-count]');
    if(!slides.length||!count)return;let current=0,startX=0,startY=0;
    const show=index=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==current);dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===current)));count.textContent=`${current+1} / ${slides.length}`;};
    this.querySelector('[data-osk-prev]')?.addEventListener('click',()=>show(current-1),{signal});this.querySelector('[data-osk-next]')?.addEventListener('click',()=>show(current+1),{signal});
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i),{signal}));
    this.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(current+1);}if(event.key==='ArrowLeft'){event.preventDefault();show(current-1);}},{signal});
    this.addEventListener('pointerdown',event=>{startX=event.clientX;startY=event.clientY;},{passive:true,signal});
    this.addEventListener('pointerup',event=>{const dx=event.clientX-startX,dy=event.clientY-startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))show(current+(dx<0?1:-1));},{passive:true,signal});show(0);
  }
}
class OskerinComparison extends OskerinComponent {
  setup(signal) {this.querySelector('input')?.addEventListener('input',event=>{if(event.target instanceof HTMLInputElement)this.style.setProperty('--compare',event.target.value+'%');},{signal});}
}
class OskerinProductForm extends OskerinComponent {
  setup(signal) {
    const form=this.querySelector('form'),button=form?.querySelector('[type=submit]'),status=form?.querySelector('[data-osk-add-status]');
    if(!(form instanceof HTMLFormElement)||!(button instanceof HTMLButtonElement)||!(status instanceof HTMLElement))return;
    const strings=window.oskerinStrings;
    form.addEventListener('submit',async event=>{
      event.preventDefault();button.disabled=true;status.textContent=strings.adding;
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'},signal});const result=await response.json();if(!response.ok)throw new Error(result.description||strings.retry);
        status.replaceChildren(document.createTextNode(strings.added));const anchor=document.createElement('a');anchor.href='/cart';anchor.textContent=strings.viewBag;status.appendChild(anchor);
        const cart=await fetch('/cart.js',{signal}).then(r=>r.json());for(const node of document.querySelectorAll('[data-osk-cart-count]'))node.textContent=cart.item_count;
      }catch(error){if(!signal.aborted)status.textContent=error.message||strings.retry;}finally{if(!signal.aborted)button.disabled=false;}
    },{signal});
  }
}

class OskerinCwill extends OskerinComponent {
  setup(signal) {
    this.observer?.disconnect();
    const emailLabel=window.oskerinStrings.emailAddress;
    const adapt = () => {
      for(const input of this.querySelectorAll('#pp-tracking-page-app input[name="email"]')) {
        if(!(input instanceof HTMLInputElement))continue;
        const labelId=input.getAttribute('aria-labelledby');
        const label=labelId?document.getElementById(labelId):null;
        if(label && label.textContent.trim()!==emailLabel)label.textContent=emailLabel;
        if(input.type!=='email')input.type='email';
        input.setAttribute('aria-label',emailLabel);input.inputMode='email';input.autocomplete='email';
      }
    };
    adapt();this.observer=new MutationObserver(adapt);this.observer.observe(this,{childList:true,subtree:true,characterData:true});
    signal.addEventListener('abort',()=>this.observer?.disconnect(),{once:true});
  }
}

for(const [name,component] of [['osk-cwill',OskerinCwill],['osk-header',OskerinHeader],['osk-carousel',OskerinCarousel],['osk-comparison',OskerinComparison],['osk-product-form',OskerinProductForm]])if(!customElements.get(name))customElements.define(name,component);
